const isSupportWebp = function(){
    var str= navigator.userAgent.toLowerCase(); 
    var ver=str.match(/cpu iphone os (.*?) like mac os/);
    if(ver){
    ver = ver[1].replace(/_/g, ".")
        if(ver.split('.')[0]>=14){
            return true
        }else{
            return false
        }
    }else{
        const ele = window.document.createElement('canvas')
        if (!!(ele.getContext && ele.getContext('2d'))) {
            return ele.toDataURL('image/webp').indexOf('webp')>-1
        }
        //不支持canvas,那么一定不支持webp
        return false
    }
    
   
}
// fe-m等使用nuxt服务器渲染的项目，本方法会报错
var ifSupportWebp =  (process.client || process.client == undefined) ? isSupportWebp() : undefined
/******** 图片拼参统一入口 ********/
const imgUrlFilter = function (imageUrl, _width, _height) {
    const width = Number(_width) || 1081
    const height = Number(_height)
    //如果图片链接不存在，直接返回 
    if (!imageUrl) {
        return imageUrl;
    }
    
    /* gif图不做处理 */
    var strFilter = ".gif"
    if(imageUrl.indexOf(strFilter) > -1) {
        return imageUrl
    }

    /******** 域名逻辑 ********/

    var resultUrl = imageUrl.split('?')[0];

    //如果链接host不含摩点图片域名，不再替换拼接参数-防止三方链接拼接参数后异常
    if (resultUrl.indexOf('.moimg.net') == -1) {

        return imageUrl;
    }

    let hostArray = ['up.moimg.net', 'p.moimg.net', 'u.moimg.net', 'i2.modian.com', 'qiniu.modian.com'];

    for (var hostUrl of hostArray) {

        if (resultUrl.indexOf(hostUrl) != -1) {

            //如果包含以上五个域名-统一替换为p6域名，否则阿里图片参数不生效
            resultUrl = resultUrl.replace(hostUrl, 'p6.moimg.net');

            break;
        }
    }



    /******** 参数逻辑 ********/

    var imageUrlParams = '?x-oss-process=image/resize'

    if ((width <= 0 && height <= 0) ||
        (width == undefined && height == undefined)) {

        //如果无宽高-则拼接兜底宽度参数
        imageUrlParams = imageUrlParams + ',w_' + 750;

    }
    else {

        //如果宽有值-则拼接宽度参数
        if (width > 0) {

            imageUrlParams = imageUrlParams + ',w_' + width;
        }

        //如果高有值-则凭借高度参数
        if (height > 0) {

            imageUrlParams = imageUrlParams + ',h_' + (height > 10000 ? 10000 : height);
        }

    }

    imageUrlParams = imageUrlParams + ',m_lfit/' + (ifSupportWebp ? 'format,webp/' : '') +'quality,Q_80/auto-orient,1/sharpen,100/ignore-error,1';


    if (resultUrl.indexOf('?') != -1) {

        //含有?则清除?后所有参数-然后拼接阿里参数
        resultUrl = resultUrl.split('?')[0] + imageUrlParams;

    } else {

        //不含?-直接拼接阿里参数
        resultUrl = resultUrl + imageUrlParams;

    }


    return resultUrl;
}

export default imgUrlFilter